import { useDispatch } from 'react-redux';
import UILink from 'UIComponents/link/UILink';
import UIButton from 'UIComponents/button/UIButton';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { tagArticlesWithTerm } from '../../../actions/TagsActions';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchTermCellContent = ({
  row,
  value,
  valueLabels,
  usageTrackerObj,
  getSearchTermUrl = __value => null
}) => {
  const dispatch = useDispatch();
  const onTagArticlesClick = () => {
    dispatch(tagArticlesWithTerm(value));
    UsageTracker.track('kbInsightsInteraction', usageTrackerObj);
  };
  const hasResults = row.get('total_search_results_found') > 0;
  const href = getSearchTermUrl(value);
  return /*#__PURE__*/_jsxs("td", {
    style: {
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    children: [/*#__PURE__*/_jsx("span", {
      children: hasResults && href ? /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: href,
        truncate: true,
        children: valueLabels.first()
      }) : valueLabels.first()
    }), /*#__PURE__*/_jsx(UITableHoverContent, {
      shrinkOnHide: false,
      children: /*#__PURE__*/_jsx(UIButton, {
        className: "m-left-4",
        use: "tertiary-light",
        size: "extra-small",
        onClick: onTagArticlesClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.insights.dashboard.articleTagging.tagArticlesButton"
        })
      })
    })]
  });
};
export default SearchTermCellContent;